export const status = {
  success: true,
  failed: false
};
